<section class="centered-with-padding grid grid-cols-1 gap-x-4 gap-y-5 py-7 desk:grid-cols-2">
  <div class="flex flex-col justify-center gap-6 rounded-xl bg-gray-light p-6">
    <div class="h-[349px] desk:h-[268px]">
      <app-image [image]="data.image" [isPriority]="!isImageInPreviousBlocks" [keepAspectRatio]="true" />
    </div>
    <div class="mx-auto w-fit">
      @let gtmView = data.gtmConfigViewBtn;
      <app-button
        (onButtonClick)="
          emitGtmEvent({
            event: gtmView?.event,
            group: gtmView?.group,
            description: gtmView?.description,
            context: gtmView?.context,
            button_text_value: data.cta.label,
            event_type: 'click',
          })
        "
        [label]="data.cta.label"
        [url]="data.cta.url" />
    </div>
  </div>
  <div class="relative flex items-center rounded-xl bg-pink p-6">
    @if (isSuccess()) {
      <ng-container [ngTemplateOutlet]="success" />
    }
    <ng-container [ngTemplateOutlet]="form" />
  </div>
</section>

<ng-template #form>
  <div #anchor [class.opacity-0]="isSuccess()" [class.pointer-events-none]="isSuccess()" class="flex flex-col gap-4">
    <app-title [title]="data.title" size="h2" />
    @let isSubmitted = isFormSubmitted();
    @let isInvalid = isFormValid().status === "KO";
    @let errors = isFormValid().errors!;
    <div (viewportObserver)="isInputVisible.set($event)" class="relative">
      <label class="mb-1 block font-bold" for="email">
        {{ "COMPONENT.FORMULAIRE-CATALOGUE.LABEL_EMAIL" | translate }}
      </label>
      <input
        (input)="onInputChange($event)"
        [value]="email()"
        class="h-7 w-full rounded-[10px] border bg-transparent px-4 py-5 desk:w-96"
        id="email"
        maxlength="255"
        type="email" />
      @if (isSubmitted && isInvalid && errors.email) {
        <div class="absolute -bottom-4 text-[10px] text-error">
          {{ errors.email | translate }}
        </div>
      }
    </div>
    <div class="flex items-center gap-2.5">
      <input (input)="onInputChange($event)" [checked]="optin()" class="sr-only" id="optin" type="checkbox" />
      <app-checkbox [(checked)]="optin" />
      <label class="cursor-pointer" for="optin">{{ data.textOptin }}</label>
    </div>
    <div [innerHTML]="data.text" class="pb-6 [&_a]:underline" handleHtmlLinks></div>
    <div class="relative">
      <div class="mx-auto w-fit">
        @let buttonLabel = "COMPONENT.FORMULAIRE-CATALOGUE.DOWNLOAD_CATALOG" | translate;
        <app-button (onButtonClick)="onSubmit(buttonLabel)" [isLoading]="isSending()" [label]="buttonLabel" />
      </div>
      @if (isApiError()) {
        <div class="absolute -bottom-5 w-full text-center text-[10px] text-error">
          {{ "COMPONENT.FORMULAIRE-CATALOGUE.FORM_ERROR" | translate }}
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div class="absolute inset-0 flex flex-col justify-center gap-4 p-5">
    <app-title
      [title]="{ text: 'COMPONENT.FORMULAIRE-CATALOGUE.CATALOG_WAITING_IN_MAILBOX' | translate, as: 'h2' }"
      size="h2" />
    <span>{{ "COMPONENT.FORMULAIRE-CATALOGUE.CATALOG_SENT_TO_EMAIL" | translate: { email: email() } }}</span>
    <span>{{ "COMPONENT.FORMULAIRE-CATALOGUE.CHECK_SPAM_IF_NOT_RECEIVED" | translate }} </span>
  </div>
</ng-template>
